import axios from 'axios'

const API_BASE = '/api/race-manager'
const TIMEOUT = 10000

const api = axios.create({
  baseURL: API_BASE,
  timeout: TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Include session cookies
})

// Events
export const getEvents = async (page = 1) => {
  const response = await api.get('/events/', { params: { page } })
  return response.data
}

export const getEvent = async id => {
  const response = await api.get(`/events/${id}/`)
  return response.data
}

// Results
export const getFinalResults = async eventId => {
  const response = await api.get(`/events/${eventId}/final-results/`)
  return response.data
}

export const getQualifications = async (eventId, pilotId = null) => {
  const params = pilotId ? { pilot_id: pilotId } : {}
  const response = await api.get(
    `/events/${eventId}/qualifications/`,
    { params }
  )
  return response.data
}

export const getEliminations = async eventId => {
  const response = await api.get(`/events/${eventId}/eliminations/`)
  return response.data
}

// Placeholder methods for future implementation
export const getLiveRace = async raceId => {
  throw new Error('Live race endpoint not implemented yet')
}

export const getRaceSchedule = async eventId => {
  throw new Error('Race schedule endpoint not implemented yet')
}

// Error handling interceptor
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      // Server responded with error status
      console.error(
        'API Error:',
        error.response.status,
        error.response.data
      )

      // Handle auth errors
      if (error.response.status === 401) {
        // Unauthorized - redirect to login handled by AuthContext
        window.dispatchEvent(new Event('auth:unauthorized'))
      } else if (error.response.status === 403) {
        // Forbidden - user doesn't have permission
        console.warn('Permission denied for this action')
      }
    } else if (error.request) {
      // Request made but no response
      console.error('Network Error:', error.message)
    } else {
      console.error('Error:', error.message)
    }
    return Promise.reject(error)
  }
)

export default api
